import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { WorksheetAction } from '@pbx/services/formatter/WorksheetAction';

class WorksheetServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getScheme(id) {
    return this.http
      .get(`/${id}/schema`)
      .then(item => WorksheetAction.formatItemFromBackend(item))
      .then(({ items }) => ({ id, items }));
  }
}

export const WorksheetService = new WorksheetServiceClass({
  api_version: 2,
  resource: 'pbx/worksheets'
});
